import React from 'react'
import styles from '../../Css/CustomSettings.module.css'

function DownloadScreenBulk(props) {

    return (
        <div>
            <div className={[styles['right-content-area'], styles['download-right'], 'row m-0  download-page'].join(' ')}>
                <div className={[styles['download-popup-bulk'], 'col-md-12 text-center'].join(' ')}>
                    {props.isZipReady ?
                        <>
                            <img alt="" src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/download-gif.gif" />
                            {!props.downloadZipLink ?
                                <div>
                                    <input id="dissatisfied-output" type="checkbox" onChange={() => props.setIsDisSatisfied(!props.isDisSatisfied)} />
                                    <span onClick={() => {
                                        document.getElementById('dissatisfied-output').checked = !document.getElementById('dissatisfied-output').checked;
                                        props.setIsDisSatisfied(!props.isDisSatisfied)
                                    }}>Dissatisfied with the Output ?</span>
                                    {props.isDisSatisfied ?
                                        <p className={[styles['refund-img']]}>Click <img src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/Group%205893821.svg" />
                                            on Images to request refund</p>
                                        :
                                        null
                                    }
                                </div>
                                :
                                null
                            }
                        </>
                        :
                        <img className={[styles['pricessing-logo']].join(' ')} alt="" src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/images-gif.gif" />
                    }
                    <div className={[styles['border-1'], ''].join(' ')}></div>
                    <div className="mb-3 text-center">
                        <button onClick={props.downloadImages} className={[styles['download-btn-hd']]} disabled={props.isZipReady && !props.isDisSatisfied ? false : true}>Download All</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DownloadScreenBulk